import { LegalPage } from "@/components/LegalPage";

export default function Privacy() {
  return <LegalPage endpoint="privacy" heading="Privacy Policy" title="Privacy Policy" />;
}
